<template>
  <div class="page-wrapper">
    <Tabs  v-model="current" >
      <TabPane name="1" label="用户管理" v-if="p('user/getUserList')">
        <c1></c1>
      </TabPane>
<!--      <TabPane name="2" label="商机电话配置" v-if="p('baseRule/getZOlist')">-->
<!--        <c2></c2>-->
<!--      </TabPane>-->
    </Tabs>
  </div>
</template>

<script>
  import C1 from '@/views/systemManage/user/index'
  import C2 from '@/views/managementCenter/permissions/index'
  import {mixin} from "../../../mixin";

  export default {
    name:'user',
    mixins:[mixin],
    components:{
      C1,
      C2,

    }        ,
    data(){
      return {
        current:null
      }
    }

  }
</script>

<style scoped>

</style>
